class ResourceFolders
  SLIDE_WIDTH  : 192
  SLIDE_MARGIN : 10

  constructor: (resource_container) ->
    @resource_container = resource_container
    @id = resource_container.find('.folder-slider')[0].id || resource_container[0].id

  activate: ->
    $foldersSlider = @resource_container.find('.folder-slider')
    that = this
    return unless $foldersSlider.length
    $foldersSlider.on('shown.bs.collapse', () ->
      `import(/* webpackChunkName: 'bxslider' */ 'js/vendor/bxslider')`.then(() ->
        that.showFolders()
      )
    )
    $foldersSlider.on('hidden.bs.collapse', @hideFolders)

  deactivate: ->
    $foldersSlider = @resource_container.find('.folder-slider')
    $foldersSlider.collapse('hide')
    @hideFolders()
    $foldersSlider.unbind('shown.bs.collapse', @showFolders)
    $foldersSlider.unbind('hidden.bs.collapse', @hideFolders)

  showFolders: =>
    if @slider
      @resource_container.find('.folder-slider').find('.bxslider').css(visibility: 'visible')
      @slider.reloadSlider()
      @setViewportMargin()
      @resizeCardText()
    else
      @populateSlider()
    @increaseViewport()

  increaseViewport: =>
    $viewport = @resource_container.find('.folder-slider').closest('.panel-rrp .bx-viewport')
    if $viewport.length
      sliderVisible = setInterval( (->
        if @resource_container.find('.folder-slider').find('.bx-wrapper').is(':visible')
          @viewportHeightAdjustment = @resource_container.find('.folder-slider').outerHeight(true)
          $viewport.height($viewport.height() + @viewportHeightAdjustment)
          clearInterval(sliderVisible)
      ).bind(@), 100)
    # hack for some versions of Safari to display the tile's right border
    @resource_container.find('.folder-slider').find('.bx-viewport').width('101%') if LP.isSafari() and LP.isMac()

  hideFolders: =>
    @resource_container.find('.folder-slider').find('.bxslider').css(visibility: 'hidden')
    @restoreViewport()

  restoreViewport: =>
    viewport = @resource_container.find('.folder-slider').closest('.panel-rrp .bx-viewport')
    if viewport.length && @viewportHeightAdjustment
      viewport.height(viewport.height() - @viewportHeightAdjustment)

  populateSlider: ->
    that = @
    $folderSlider = @resource_container.find('.folder-slider')
    if $folderSlider.length > 0 && $folderSlider.data('slider-link') && $folderSlider.is(':empty')
      $.get($folderSlider.data('slider-link'), (response) ->
        $folderSlider.html(response);
        that.createSlider();
      )
    else
      @createSlider();

  createSlider: ->
    @MAX_SLIDES = @maxSlides()
    @slider = @resource_container.find('.folder-slider').find('.bxslider').bxSlider
      slideWidth: @SLIDE_WIDTH
      maxSlides: @MAX_SLIDES
      slideMargin: @SLIDE_MARGIN
      autoStart: false
      pager: true
      infiniteLoop: false
      hideControlOnEnd: true
      pagerSelector: "##{@id} .col-slider-pager"
      nextSelector: "##{@id} .col-slider-next"
      prevSelector: "##{@id} .col-slider-prev"
      nextText: '<div class="btn btn-default"><span class="hidden-xs">Next</span><i class="fa-solid fa-lg fa-arrow-right ml5"></i></div>'
      prevText: '<div class="btn btn-default"><i class="fa-solid fa-lg fa-arrow-left mr5"></i><span class="hidden-xs">Previous</span></div>'
      onSliderLoad: @showSlider
      onSliderResize: @setViewportMargin
      touchEnabled: !LP.isDesktop() # cannot click on items on latest Chrome & jQuery
    @setViewportMargin()

  maxSlides: ->
    width = @resource_container.find('.folder-slider').width()
    Math.floor(Math.min(3, width / (@SLIDE_WIDTH + @SLIDE_MARGIN)))

  setViewportMargin: =>
    container_width = @resource_container.find('.folder-slider').width()
    slides_per_page = @slidesPerPage()
    nr_margins = slides_per_page - 1
    margin = (container_width - (slides_per_page * @SLIDE_WIDTH + nr_margins * @SLIDE_MARGIN)) / 2
    @resource_container.find('.folder-slider').find('.bx-viewport').css('marginLeft', margin)

  slidesPerPage: ->
    doc_width = $(document).width()
    nrSlides = switch
      when doc_width < 490
        1
      when doc_width < 1200
        2
      else
        3
    Math.min(@MAX_SLIDES, nrSlides)

  showSlider: =>
    @resource_container.find('.folder-slider').find('.bxslider').css(visibility: 'visible')
    @resizeCardText()

  resizeCardText: ->
    fudgeFactor = 1
    $('.panel-resource .col-resource-heading').outerWidth ->
      $(@).closest('.panel-body').outerWidth() - $(@).siblings('.col-resource-icon').outerWidth() - fudgeFactor

LP.module('Resources').ResourceFolders = ResourceFolders
